import { getResourceFilters } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
export const useGetResourceFilters = (userId: string) => {
  const { data, status, refetch } = useQuery(
    ['resource-filters', userId],
    () => getResourceFilters(userId),
    {
      staleTime: 60000,
    }
  );

  return {
    storedFilters: data,
    storedFiltersStatus: status,
    fetchStoredFilters: refetch,
  };
};
